// import React, { useState } from "react";
// import { Box, Slide, Typography, useMediaQuery, useTheme } from "@mui/material";
// import theme from "../theme";
// import DayEndReport from "./DayEndReport";
// import WeeklyReport from "./WeeklyReport";

// const TAB_LABELS = {
//   daily: "Daily",
//   weekly: "Weekly",
// };

// const Report = () => {
//   const muiTheme = useTheme();
//   const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));

//   const [activeTab, setActiveTab] = useState("daily");

//   const handleTabChange = (key) => {
//     setActiveTab(key);
//   };

//   return (
//     <Box>
//       {/* ---------- Tabs Container ---------- */}
//       <Box
//         sx={{
//           mt: isMobile ? 0 : 1,
//           width: isMobile ? "100vw" : "100%",
//           marginX: -2,
//           boxShadow: !isMobile ? "0 2px 5px #bdbdbd" : "none",
//           bgcolor: "#fff",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             width: isMobile ? "100vw" : "220px",
//             px: isMobile ? 2 : 0,
//             background: isMobile ? theme.lightTheme.header.home : "#fff",
//             height: isMobile ? "50px" : "36px",
//             alignItems: "center", // ✅ FIXED (was "end")
//             zIndex: 1000,
//           }}
//         >
//           {Object.entries(TAB_LABELS).map(([key, label]) => {
//             const isActive = activeTab === key;

//             return (
//               <Typography
//                 key={key}
//                 onClick={() => handleTabChange(key)}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   height: isMobile ? "36px" : "100%",
//                   width: "100px",
//                   background: isMobile
//                     ? isActive
//                       ? "#fff"
//                       : ""
//                     : isActive
//                     ? "linear-gradient(90deg,rgba(0, 128, 128, 1) 0%, rgba(68, 40, 160, 1) 100%)"
//                     : "#fff",
//                   borderRadius: isMobile ? "8px 8px 0 0" : "0",
//                   fontSize: isMobile ? 12 : 14,
//                   cursor: "pointer",
//                   color: isMobile
//                     ? isActive
//                       ? "black"
//                       : "#fff"
//                     : isActive
//                     ? "#fff"
//                     : "black",
//                   fontWeight: isActive ? 600 : 400,
//                   transition: "all 0.2s ease",
//                   lineHeight: 1, // ✅ prevents text offset
//                 }}
//               >
//                 {label}
//               </Typography>
//             );
//           })}
//         </Box>
//       </Box>

//       {/* ---------- Tab Content ---------- */}
//       <Box sx={{ p: isMobile ? 2 : 1, overflow: "hidden" }}>
//         <Slide
//           direction="right"
//           in={activeTab === "daily"}
//           timeout={300}
//           mountOnEnter
//           unmountOnExit
//         >
//           <Box>
//             <DayEndReport />
//           </Box>
//         </Slide>

//         <Slide
//           direction="left"
//           in={activeTab === "weekly"}
//           timeout={300}
//           mountOnEnter
//           unmountOnExit
//         >
//           <Box>
//             <WeeklyReport />
//           </Box>
//         </Slide>
//       </Box>
//     </Box>
//   );
// };

// export default Report;
import React, { useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import DayEndReport from "./DayEndReport";
import WeeklyReport from "./WeeklyReport";

const TABS = [
  { key: "daily", label: "Daily Report" },
  { key: "weekly", label: "Weekly Report" },
];

const Report = () => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));
  const [activeTab, setActiveTab] = useState("daily");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#ebebeb85",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <Box sx={{ px: 8, bgcolor: "#ffff" }}>
        {" "}
        <Box
          sx={{
            bgcolor: "#fff",
            borderBottom: "1px solid #e8e8e4",

            display: "flex",
            alignItems: "flex-end",
            gap: 0,
            position: "sticky",
            top: 0,
            zIndex: 100,
          }}
        >
          {TABS.map(({ key, label }) => {
            const isActive = activeTab === key;
            return (
              <Box
                key={key}
                onClick={() => setActiveTab(key)}
                sx={{
                  px: isMobile ? 2 : 3,
                  py: 1.5,
                  cursor: "pointer",
                  fontSize: isMobile ? 13 : 14,
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? "#111" : "#999",
                  borderBottom: isActive
                    ? "2px solid #111"
                    : "2px solid transparent",
                  transition: "all 0.18s ease",
                  letterSpacing: "-0.01em",
                  userSelect: "none",
                  "&:hover": {
                    color: "#111",
                  },
                }}
              >
                {label}
              </Box>
            );
          })}
        </Box>
        {/* Content */}
        <Box>
          {activeTab === "daily" && <DayEndReport />}
          {activeTab === "weekly" && <WeeklyReport />}
        </Box>
      </Box>
      {/* Tab Bar */}
    </Box>
  );
};

export default Report;
